import React from "react";
import Moment from "react-moment";
import sanitise from "./sanitise";

const LastUpdate = props => {
  if (!props.children) return "Never";

  return (
    <Moment fromNow interval={15000}>
      {sanitise(props.children)}
    </Moment>
  );
};

export default LastUpdate;
